import { message, notification, Modal } from 'antd'

export const appMessage = message
export const appNotification = notification
export const appModal = Modal
